var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.loading)?_c('div',{staticClass:"ant-modal-mask"},[_c('div',{staticClass:"w-100 h-100 cr-ai-center cr-jc-center"},[_c('a-spin',{attrs:{"tip":"加载中...","size":"large"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }